import { Injectable } from "@angular/core";
import { DateRangeSelectorServiceBase } from "src/shared/services/date-range-selector-service-base";
import { CVApiService } from "../services/cv-api.service";
import { SharedServiceHelperService } from "../services/shared-service-helper.service";

@Injectable({
    providedIn: 'root'
})
export class DateRangeSelectorService extends DateRangeSelectorServiceBase {
    constructor(
        sshs: SharedServiceHelperService,
        cvApiService: CVApiService,
    ) {
        super(sshs.getSharedServicesEnabled(), cvApiService);
    }
}
